"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIGITAL_TWIN_METRICS = exports.DEVICE_METRICS_BY_TYPE = exports.ALL_DEVICE_METRICS = void 0;
var chart_colors_1 = require("./chart-colors");
var SONOFF_TH_METRICS = [
    { key: "temperatureC", label: "Temperature", unit: "°C", icon: "solar:temperature-linear", digits: 1, color: chart_colors_1.CHART_COLORS.orange },
    { key: "humidityPct", label: "Humidity", unit: "%", icon: "solar:waterdrops-linear", digits: 0, color: chart_colors_1.CHART_COLORS.blue },
];
var SONOFF_POW_METRICS = [
    { key: "powerW", label: "Power", unit: "W", icon: "solar:bolt-linear", digits: 1, color: chart_colors_1.CHART_COLORS.orange },
    { key: "voltageV", label: "Voltage", unit: "V", icon: "solar:battery-charge-linear", digits: 1, color: chart_colors_1.CHART_COLORS.blue },
    { key: "currentA", label: "Current", unit: "A", icon: "solar:pulse-2-linear", digits: 2, color: chart_colors_1.CHART_COLORS.aqua },
];
var TROLMASTER_METRICS = [
    { key: "temperatureC", label: "Temperature", unit: "°C", icon: "solar:temperature-linear", digits: 1, color: chart_colors_1.CHART_COLORS.orange },
    { key: "humidityPct", label: "Humidity", unit: "%", icon: "solar:waterdrops-linear", digits: 0, color: chart_colors_1.CHART_COLORS.blue },
    { key: "co2Ppm", label: "CO2", unit: "ppm", icon: "solar:cloud-linear", digits: 0, color: chart_colors_1.CHART_COLORS.aqua },
    { key: "vpd", label: "VPD", unit: "kPa", icon: "solar:wind-linear", digits: 2, color: chart_colors_1.CHART_COLORS.magenta },
    { key: "ph", label: "pH", unit: "", icon: "solar:test-tube-linear", digits: 2, color: chart_colors_1.CHART_COLORS.green },
    { key: "ec", label: "EC", unit: "mS/cm", icon: "solar:bolt-circle-linear", digits: 2, color: chart_colors_1.CHART_COLORS.yellow },
    { key: "waterContent", label: "Water Content", unit: "%", icon: "solar:water-linear", digits: 0, color: chart_colors_1.CHART_COLORS.blue },
    { key: "moisture", label: "Moisture", unit: "%", icon: "solar:leaf-linear", digits: 0, color: chart_colors_1.CHART_COLORS.green },
    { key: "lightPower", label: "Light Power", unit: "%", icon: "solar:sun-linear", digits: 0, color: chart_colors_1.CHART_COLORS.yellow },
    { key: "lightStatus", label: "Light Status", unit: "", icon: "solar:lightbulb-linear", digits: 0, color: chart_colors_1.CHART_COLORS.neutral },
];
var DIGITAL_TWIN_METRICS = [
    { key: "flowerAreaTempC", label: "Flower Area Temp", unit: "°C", icon: "solar:temperature-linear", digits: 1, color: chart_colors_1.CHART_COLORS.orange },
    { key: "vegAreaTempC", label: "Veg Area Temp", unit: "°C", icon: "solar:temperature-linear", digits: 1, color: chart_colors_1.CHART_COLORS.green },
    { key: "facilityHumidityPct", label: "Facility Humidity", unit: "%", icon: "solar:waterdrops-linear", digits: 0, color: chart_colors_1.CHART_COLORS.blue },
    { key: "waterStorageTempC", label: "Water Storage Temp", unit: "°C", icon: "solar:water-linear", digits: 1, color: chart_colors_1.CHART_COLORS.aqua },
    { key: "lightingKwh", label: "Lighting", unit: "kWh", icon: "solar:sun-linear", digits: 1, color: chart_colors_1.CHART_COLORS.yellow },
    { key: "hvacKwh", label: "HVAC", unit: "kWh", icon: "solar:wind-linear", digits: 1, color: chart_colors_1.CHART_COLORS.magenta },
    { key: "totalFacilityKwh", label: "Total Facility", unit: "kWh", icon: "solar:bolt-linear", digits: 1, color: chart_colors_1.CHART_COLORS.neutral },
];
exports.DIGITAL_TWIN_METRICS = DIGITAL_TWIN_METRICS;
var DEVICE_METRICS_BY_TYPE = {
    TH: SONOFF_TH_METRICS,
    POW: SONOFF_POW_METRICS,
    AQUAX: TROLMASTER_METRICS,
    HYDROX: TROLMASTER_METRICS,
    HYDROXPLUS: TROLMASTER_METRICS,
};
exports.DEVICE_METRICS_BY_TYPE = DEVICE_METRICS_BY_TYPE;
/** Every known metric by key, in catalogue order; the first list to declare a shared key (temperatureC, humidityPct) wins. */
var ALL_DEVICE_METRICS = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], TROLMASTER_METRICS, true), SONOFF_TH_METRICS, true), SONOFF_POW_METRICS, true), DIGITAL_TWIN_METRICS, true).reduce(function (catalogue, metric) {
    var _a;
    return (metric.key in catalogue ? catalogue : __assign(__assign({}, catalogue), (_a = {}, _a[metric.key] = metric, _a)));
}, {});
exports.ALL_DEVICE_METRICS = ALL_DEVICE_METRICS;
